import React from "react";
import ReactDOM from "react-dom/client";
import './index.css';
// import "./assets/css/bootstrap.min.css"
import "./assets/css/core-style.css";
import { Provider } from "react-redux";
import store from "./store";
import App from "./App";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
